<template>
  <div class="modal-wrapper">
    <div 
      v-if="isVisible" 
      class="modal-overlay"
      @click="closeModal"
    ></div>

    <transition name="modal-fade">
      <div v-if="isVisible" class="cookie-modal">
        <div class="cookiie-modal-content">
          <div class="cookie-modal-title">
            <slot name="title">Мы используем cookies</slot>
          </div>
          <div class="cookie-modal-text">
            <slot name="text">
              Используя сайт, вы соглашаетесь с обработкой данных с целью сбора аналитики. 
              Cookies можно отключить в любой момент в настройках вашего браузера.
            </slot>
          </div>
        </div>
        <button class="cookie-modal-button" @click="closeModal">
          Принять
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'CookieModal',

  data() {
    return {
      isVisible: false,
      originalOverflow: window.getComputedStyle(document.body).overflow,
    };
  },

  methods: {
    lockScroll() {
      this.originalOverflow = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = 'hidden';

      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`;
      }
    },

    unlockScroll() {
      document.body.style.overflow = this.originalOverflow;
      document.body.style.paddingRight = '';
    },

    closeModal() {
      this.isVisible = false;
      this.unlockScroll();
      localStorage.setItem("cookieConfirmed", "1");
      this.$emit('close');
    }
  },

  mounted() {
    const cookieConfirmed = localStorage.getItem("cookieConfirmed");
    this.isVisible = cookieConfirmed !== "1";

    if (this.isVisible) {
      this.lockScroll();
    }
  },

  beforeUnmount() {
    // на случай если компонент уничтожится, пока модалка открыта
    this.unlockScroll();
  }
};
// export default {
//   name: 'CookieModal',
//   data() {
//     return {
//       isVisible: false,
//       originalOverflow: '',
//     };
//   },
//   methods: {
//     closeModal() {
//       this.$set(this, 'isVisible', false);
//       localStorage.setItem("cookieConfirmed", "1");
//       this.$emit('close');
//     }
//   },
//   mounted() {
//     const cookieConfirmed = localStorage.getItem("cookieConfirmed");
//     this.isVisible = cookieConfirmed !== "1";
//   },
//   watch: {
//     isVisible: {
//       handler(newValue) {
//         if (newValue) {
//           this.originalOverflow = window.getComputedStyle(document.body).overflow;
//           document.body.style.overflow = 'hidden';
//           const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
//           if (scrollbarWidth > 0) {
//             document.body.style.paddingRight = `${scrollbarWidth}px`;
//           }
//         } else {
//           requestAnimationFrame(() => {
//             document.body.style.overflow = this.originalOverflow;
//             document.body.style.paddingRight = '';
//           });
//         }
//       },
//       immediate: true
//     }
//   },
// };
</script>

<style scoped>
.cookie-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    bottom: auto;
    transform: translate(-50%, -50%);
    width: 400px;
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    background-color: white;
    padding: 24px;
    gap: 24px;
    z-index: 1000;
    box-shadow:
        0 8px 8px -4px rgba(10, 13, 18, 0.03),
        0 20px 24px -4px rgba(10, 13, 18, 0.08);
    @media (max-width: 720px) {
        width: 360px;
        border-radius: 12px 12px 0 0;
        top: auto;
        bottom: 0;
        transform: translate(-50%);
        transition: transform 0.3s ease, opacity 0.3s ease;
    }
}

.cookie-modal-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.cookie-modal-title {
    font-family: "PT Sans", sans-serif;
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    color: black;
}

.cookie-modal-text {
    font-family: "PT Sans", sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    line-height: 100%;
    color: #535862;
    letter-spacing: 0;
}

.cookie-modal-button {
    width: 100%;
    border-radius: 8px;
    background-color: #6699CC;
    font-family: "PT Sans", sans-serif;
    font-weight: 700;
    font-size: 14px;
    color: white;
    padding: 12px;
    border: none;
    cursor: pointer;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  z-index: 999;
}
</style>